import { handleActions } from "redux-actions";
import { SetLocale } from "../actions/actions";

export default handleActions(
  {
    [SetLocale]: (state, action) => {
      return action.payload;
    }
  },
  ""
);
